import { useState, useEffect, useRef, forwardRef } from 'react';
import { colors } from '../../constants';

export const PillButtons = forwardRef((props, ref) => {
  const { value, onChange, choices, wrapperStyle, pillStyle, size } = props;

  const borderRadius = 8;

  const activeStyle = {
    fontWeight: 'bold',
    background: colors.primaryLight,
    color: colors.primaryDark,
  };

  const nodes = choices.map(([val, label]) => {
    let sizeStyles;
    if (size == 'sm') {
      sizeStyles = {
        fontSize: 12,
        padding: '5px 12px',
        borderRadius: 24,
      };
    }

    const style = {
      cursor: 'pointer',
      padding: '8px 20px',
      textAlign: 'center',
      borderRadius,
      ...sizeStyles,
      ...(pillStyle || {}),
      ...(val == value ? activeStyle : {}),
    };

    return (
      <div key={val} style={style} onClick={() => onChange(val)}>
        {label || val}
      </div>
    );
  });

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        borderRadius,
        ...wrapperStyle,
      }}
    >
      {nodes}
    </div>
  );
});
